import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language?.startsWith('es') ? 'es' : 'en';

  const toggleLang = () => {
    const next = currentLang === 'es' ? 'en' : 'es';
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={toggleLang}
      className="relative flex items-center gap-1 px-3 py-1.5 rounded-full border border-gray-200 bg-gray-50/60 text-xs font-semibold tracking-wider text-gray-600 hover:border-primary-300 hover:text-primary-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
      aria-label={`Switch to ${currentLang === 'es' ? 'English' : 'Español'}`}
    >
      <span className={currentLang === 'es' ? 'text-primary-500' : ''}>{t('lang.es')}</span>
      <span className="text-gray-300">/</span>
      <span className={currentLang === 'en' ? 'text-primary-500' : ''}>{t('lang.en')}</span>
    </button>
  );
}